import {ChangeDetectorRef, Directive, ElementRef, HostBinding, inject, Input, NgZone, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Block, BlockType, Column, Group} from '@paperlessio/sdk/api/models';
import {EditorRoutingService} from '@management/editor/editor-routing.service';
import {EditorService} from '@management/editor/editor.service';
import {BLOCKS_CONFIG} from './blocks.config';
import {DraggableService} from './draggable/draggable.service';
import {BlockChangeDetectionService} from '@blocks/services/block-change-detection/block-change-detection.service';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class BlocksComponent implements OnInit, OnDestroy {
  BlockType = BlockType;

  @Input() block: Block | Group | Column;

  @HostBinding('class.empty') get empty(): boolean {
    return this.blocksConfig.editable && !this.children.length;
  }

  get children() {
    return this.block.children;
  }

  @HostBinding('class.pdf-page') get pdfPage() {
    return this.block.type === BlockType.Page && this.children.some(c => c.type === BlockType.PdfPart);
  }

  get pdfPartChild() {
    return this.block.parent?.type === BlockType.PdfPart;
  }

  subs = new Subscription();
  private unlistenFunctions: any[] = [];

  editorRouter = inject(EditorRoutingService, {optional: true});
  editorService=inject(EditorService, {optional: true});
  blocksConfig = inject(BLOCKS_CONFIG);
  draggableService = inject(DraggableService, {optional: true});
  blockChangeDectionService = inject (BlockChangeDetectionService);
  changeDetectorRef = inject(ChangeDetectorRef);
  zone = inject(NgZone);
  elementRef = inject(ElementRef);
  renderer = inject(Renderer2);

  ngOnInit() {
    if (this.block && !this.block.parent_id) {
      this.enableDragAndDropForRootBlock();
    }
    this.subscribeToBlockChanges();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.unlistenFunctions.forEach(unlistenFunction => {
      if (unlistenFunction && typeof unlistenFunction === 'function') {
        unlistenFunction();
      }
    });
  }

  public trackByFn(index, item: Block) {
    return item ? item.id : null;
  }

  // to avoid multiple change detection cycles we trigger change detection manually
  // when the block is in the list of changed blocks
  private subscribeToBlockChanges() {
    this.subs.add(
      this.blockChangeDectionService.changedBlockIds$.pipe(
        filter((blockId: number) => blockId === this.block.id),
      ).subscribe(() => {
        this.changeDetectorRef.markForCheck();
      })
    );
  }

  private enableDragAndDropForRootBlock() {
    this.zone.runOutsideAngular(() => {
      this.unlistenFunctions.push(this.renderer.listen(this.elementRef.nativeElement, 'dragover', () => {
        return !this.draggableService?.isDragging$.value;
      }));
    });
  }
}
